

import React from 'react';







const defaults = {
  setObjectForKey: () => {},
  updateObjectForKey: () => {},
  getObjectForKey: () => {}
};

const globalStoreContext = React.createContext(defaults);

export default globalStoreContext;
export const GlobalStoreConsumer = globalStoreContext.Consumer;